
export default class Events {
    static SHOW_LOADING_PAGE = 'SHOW_LOADING_PAGE';
    static HIDE_LOADING_PAGE = 'HIDE_LOADING_PAGE';

    static PAUSE_DFAST = 'PAUSE_DFAST';
    static UNPAUSE_DFAST = 'UNPAUSE_DFAST';

    static REFRESH_ALL_RAVENS = 'REFRESH_ALL_RAVENS';
    static REFRESH_RAVEN = 'REFRESH_RAVEN';
    static REFRESH_MEDIA = 'REFRESH_MEDIA';

    static ENHANCED_VIDEO_ACCESS_ROUTE_HIGHLIGHT_REQUEST = "ENHANCED_VIDEO_ACCESS_ROUTE_HIGHLIGHT_REQUEST"; // listened to by Dashboard and History maps
    static enhancedVideoAccessRouteHighlightRequest = (ravenUuid, startIndex = 0, endIndex = 0) => {
        document.dispatchEvent(
            new CustomEvent(Events.ENHANCED_VIDEO_ACCESS_ROUTE_HIGHLIGHT_REQUEST, {
                detail: {
                    ravenUuid: ravenUuid,
                    startIndex: startIndex,
                    endIndex: endIndex
                }
            })
        );
    }

    static SELECT_EVENT = 'SELECT_EVENT';

    static refreshAllRavens = () => new CustomEvent(Events.REFRESH_ALL_RAVENS);

    static refreshMedia = (mediaId, reason) => new CustomEvent(Events.REFRESH_MEDIA, { detail: { mediaId, reason } });

    static showLoading = (args) => {
        if (!args) args = {};
        const { message, override, style, safeToReload } = args;
        return new CustomEvent(Events.SHOW_LOADING_PAGE, { detail: { loadingPageMessage: message, override, style, safeToReload } });
    }
    static hideLoading = () => new CustomEvent(Events.HIDE_LOADING_PAGE);

}
